import { componentProvider } from 'js-component-framework/es';
import breakpoints from '@/js/utils/breakpoints';
import PriorityNav from './PriorityNav';

/**
 * MenuBarOverflow class.
 *
 * Handle the menubar overflow.
 */
class MenuBarOverflow {
  /**
   * Start the component
   */
  constructor({ children, element, options }) {
    this.children = children;
    this.element = element;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);
    this.setPriorityNav = this.setPriorityNav.bind(this);
    this.handlePriorityNavInit = this.handlePriorityNavInit.bind(this);
    this.handlePriorityNavDestroy = this.handlePriorityNavDestroy.bind(this);

    this.init();
    breakpoints.lgMin.addEventListener('change', this.init);
  }

  /**
   * Handle the overflow menu init event.
   */
  handlePriorityNavInit() {
    this.element.classList.add('priority-nav--init');
  }

  /**
   * Handle the overflow menu destroy event.
   */
  handlePriorityNavDestroy() {
    this.element.classList.remove('priority-nav--init');
  }

  /**
   * Set up and initializes the priority nav.
   */
  setPriorityNav() {
    const { menu } = this.children;
    let clone = this.element.querySelector('.priority-nav');

    // Add the overflow item if we don't have it already.
    if (clone === null) {
      const template = document.querySelector('#menu-bar-priority-nav');
      clone = template.content.cloneNode(true);
      menu.appendChild(clone);
    }

    const button = menu.querySelector('.priority-nav__more');
    const overflow = menu.querySelector('.priority-nav__overflow');

    this.priorityNav = new PriorityNav({
      wrapper: this.element,
      menu,
      overflow,
      button,
      onInit: this.handlePriorityNavInit,
      onDestroy: this.handlePriorityNavDestroy,
    });
  }

  /**
   * Manage PriorityNav instances.
   */
  init() {
    if (breakpoints.lgMin.matches) {
      if (this.priorityNav instanceof PriorityNav) {
        this.priorityNav.init();
      } else {
        this.setPriorityNav();
      }
    } else if (this.priorityNav instanceof PriorityNav) {
      // Destroy priorityNav for small screens.
      this.priorityNav.destroy();
    }
  }
}

const menuBarOverflowConfig = {
  name: 'menu-bar-overflow',
  component: MenuBarOverflow,
  querySelector: {
    menu: '.header-menu__list',
  },
};

componentProvider(menuBarOverflowConfig);
